import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { t } from '../../../app/i18n';
import Popover from 'antd/lib/popover';
import { loanHistoryStatusT } from '../../../common/enums';
import { formatDateTime } from '../../../common/utils/helpers';

@translate()
export default class LoanHistory extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    loans: PropTypes.array,
    isLoading: PropTypes.bool.isRequired,
    historyStatus: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    popoverVisible: PropTypes.bool.isRequired,
    handleMouseEnter: PropTypes.func.isRequired,
    handleVisibleChange: PropTypes.func.isRequired,
  };

  amountAndMonths = [
    { label: 'Suma', getData: loan => `${loan.amount} €` },
    { label: 'Počet splátok', getData: loan => loan.months },
  ];

  popoverContentMap = {
    ZAM: [
      ...this.amountAndMonths,
      { label: 'Dôvod', getData: loan => loan.rejectReason },
      { label: 'Dátum zamietnutia', getData: loan => formatDateTime(loan.updatedAt, 'D.M.YYYY HH:mm') },
    ],
    AKT: [
      ...this.amountAndMonths,
      { label: 'Počet splatených', getData: loan => loan.repaymentInfo.repayed },
      { label: 'Počet v omeškaní', getData: loan => loan.repaymentInfo.delayed }
    ],
    UHR: [
      ...this.amountAndMonths,
    ],
    CAK: [
      ...this.amountAndMonths,
    ]
  }

  getPopoverContent = (loans, historyStatus) => (
    <div className="popover-content-wrapper">
      {
        loans.map(l => (
          <div key={l.id} className="popover-dl-container">
            <h3>{`${l.loanNumber}, `}<small>{`${formatDateTime(l.createdAt, 'D.M.YYYY HH:mm')}`}</small></h3>
            <dl className="popover-dl">
              {
                this.popoverContentMap[historyStatus].map(c => (
                  <React.Fragment key={c.label}>
                    <dt>{t(c.label)}</dt>
                    <dd>{c.getData(l)}</dd>
                  </React.Fragment>
                ))
              }
            </dl>
          </div>
        ))
      }
    </div>
  );

  render() {
    const { loans, isLoading, historyStatus, count, popoverVisible, handleMouseEnter, handleVisibleChange } = this.props;

    if (!loans) {
      return (
        <React.Fragment>
          {
            count ? (
              <span onMouseEnter={handleMouseEnter} className={isLoading ? 'cursor-progress' : 'cursor-help'}>{count}</span>
            ) : (
              <span>{count}</span>
            )
          }
        </React.Fragment>
      );
    }

    return (
      <Popover
        onMouseEnter={handleMouseEnter}
        onVisibleChange={handleVisibleChange}
        content={this.getPopoverContent(loans, historyStatus)} title={`${count} ${loanHistoryStatusT[historyStatus]}`}
        visible={popoverVisible}
      >
        <span className='cursor-help'>{count}</span>
      </Popover>
    );
  }
}


// WEBPACK FOOTER //
// ./src/features/loan-management/components/LoanHistory.js